import { isFhirError, isZusAPIError } from '@ctw/shared/api/fhir/errors';
import { OperationOutcomeModel } from '@ctw/shared/api/fhir/models/operation-outcome';
import { isOperationOutcome } from '@ctw/shared/api/fhir/operation-outcome';

export function isError(error: unknown): error is Error {
  if (typeof error === 'object' && error !== null) {
    return 'message' in error;
  }
  return false;
}

export function errorMessage(error: unknown): string {
  return isError(error) ? error.message.split(':')[0] : 'An unknown error occurred';
}

export const getFormResponseErrors = (response: unknown) => {
  let requestErrors: Array<string> = [];
  let responseIsSuccess = true;

  if (isFhirError(response) && isOperationOutcome(response.response.data)) {
    requestErrors = new OperationOutcomeModel(response.response.data).issues
      .filter((issue) => issue.severity !== 'warning')
      .map((issue) => issue.display);
    responseIsSuccess = false;
  } else if (isZusAPIError(response)) {
    requestErrors = [response.response.data.message];
    responseIsSuccess = false;
  } else if (response instanceof Error) {
    requestErrors = [response.message];
    responseIsSuccess = false;
  }
  return { requestErrors, responseIsSuccess };
};
